import { combineReducers } from "redux";
import type { AppIntelligenceState } from "./types";
import urlParamsReducer from "./commonReducers/urlParamsReducer/urlParamsReducer";

const appIntelligenceReducer = combineReducers<AppIntelligenceState>({
    urlParams: urlParamsReducer,
});

export default appIntelligenceReducer;
